import isPayLaterParamEnabled from './isPayLaterParamEnabled';
var isAccountEligibleForAlertsList = function (payLaterFlag, isPayLater) {
    return (!isPayLater || (isPayLater && (payLaterFlag || isPayLaterParamEnabled())));
};
export default isAccountEligibleForAlertsList;
